import { Show } from 'solid-js'

const SimpleModal = (props: { show: boolean; onClose: () => void; children: any }) => (
  <Show when={props.show}>
    <div
      class="fixed inset-0 z-50 flex items-center justify-center bg-black/60 px-4 sm:px-0"
      onClick={props.onClose}
    >
      <div
        style="min-width: 300px; min-height: 100px;"
        onClick={(e) => e.stopPropagation()} // Prevent closing when clicking inside modal
      >
        {props.children}
      </div>
    </div>
  </Show>
)

export default SimpleModal
